import { __assign, __rest } from "tslib";
import * as React from 'react';
import { default as Combobox } from './Combobox';
import { useCreatable } from './useCreatable';
import { MenuItem } from './components/Combobox.MenuItem';
import { useComboboxContext } from './Combobox.context';
export var CreatableMenuItem = function (props) {
    var _a, _b;
    var createOptionLabel = props.createOptionLabel, components = props.components, menuItemProps = __rest(props, ["createOptionLabel", "components"]);
    var option = menuItemProps.option, selected = menuItemProps.selected, onKeyDown = menuItemProps.onKeyDown;
    var _c = useComboboxContext(), searchString = _c.searchString, focusSearch = _c.focusSearch;
    var ComboboxMenuItem = (_a = components === null || components === void 0 ? void 0 : components.MenuItem) !== null && _a !== void 0 ? _a : MenuItem;
    var CreatableMenuItem = (_b = components === null || components === void 0 ? void 0 : components.CreatableMenuItem) !== null && _b !== void 0 ? _b : MenuItem;
    if ('__isNew__' in option) {
        var createdOnKeyDown = function (event) {
            if (event.key === ' ') {
                // Focus search input on removeal of created option.
                focusSearch();
            }
            onKeyDown === null || onKeyDown === void 0 ? void 0 : onKeyDown(event);
        };
        return !selected ? (React.createElement(CreatableMenuItem, __assign({ replaceContent: true }, menuItemProps), createOptionLabel(searchString !== null && searchString !== void 0 ? searchString : ''))) : (React.createElement(ComboboxMenuItem, __assign({}, menuItemProps, { onKeyDown: createdOnKeyDown })));
    }
    return React.createElement(ComboboxMenuItem, __assign({}, menuItemProps));
};
export var CreatableCombobox = function (props, ref) {
    var components = props.components, consumerProps = __rest(props, ["components"]);
    var createOptionLabel = consumerProps.strings.createOptionLabel;
    // eslint-disable-next-line react/no-unstable-nested-components
    var Creatable = function (props) { return (React.createElement(Combobox, __assign({}, useCreatable(props)))); };
    return (React.createElement(Creatable, __assign({ ref: ref, components: __assign(__assign({}, components), { 
            // eslint-disable-next-line react/no-unstable-nested-components
            MenuItem: function (props) { return (React.createElement(CreatableMenuItem, __assign({ createOptionLabel: createOptionLabel, components: components }, props))); } }) }, consumerProps)));
};
var CreatableComboboxRef = React.forwardRef(CreatableCombobox);
export default CreatableComboboxRef;
//# sourceMappingURL=CreatableCombobox.js.map